import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import { withStyles } from "@material-ui/core/styles";
import PageTitle from "../../../components/common/PageTitle";
import Button from "@material-ui/core/Button";

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import  api from '../../common/api';

import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import MediaFile from '../../../components/common/MediaFile'
import Typography from '@material-ui/core/Typography';

import Avatar from '@material-ui/core/Avatar';
import FolderIcon from '@material-ui/icons/Folder';
import MenuItem from '@material-ui/core/MenuItem';


const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem',
  },
});

class BrandsForm extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			dialogOpen: false,
			loading: true,
			errors: false,
			delete_logo: false,
			brand:{
				dnrpa_code: '', dnrpa_description:'', dnrpa_maker:'',
				aldnet_code:'', aldnet_description:'', aldnet_maker:'', aldnet_maker_group: '',
				media:[],
			},
			files:[],
			aldnet_makers:[],
			logo: false
		}
	}

	async componentDidMount() {
		var params = this.getParams();
		var brand_id = params.id
		var view = params.view
		await this.getAldnetMakers();
		if (brand_id !== undefined){
			await this.getBrand(brand_id);
			if (view !== undefined){
				this.setState({disabled: true, action: 'view'})
			} else {
				this.setState({action: 'edit'})
			}
		} else {
			this.setState({action: 'new', loading: false})
		}
	}

	getParams(){
		return this.props.match.params
	}

	getAldnetMakers = () => {
	    const token =localStorage.getItem('userToken')
	    return axios
	         .get(api.brands().aldnet_makers(),{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	              res.data = Object.values(res.data);
	              this.setState({aldnet_makers: res.data})
	          })
	          .catch(err =>{console.log(err)
	          })
	}

	getBrand(id){
	    const token = localStorage.getItem('userToken')
	    return axios
	         .get(api.brands().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	              res.data = Object.values(res.data);
	              var logo = (res.data[0].media.length > 0 ) ? true : false
	              this.setState({brand: res.data[0], loading: false, logo: logo })
	              return res.data
	          })
	          .catch(err =>{console.log(err)
	          })
	}

 	handleChange = (event) => {
	    event.preventDefault();	
	    var key = event.target.name
	    var value = event.target.value
	    var brand = this.state.brand
	    brand[key] = value
	    this.setState({brand: brand})
 	}

	handleUploadFile = (file, meta_data) => {
		var files_state = this.state.files
		var file = {file: file, meta_data: meta_data}
		files_state.push(file)
		this.setState({files: files_state})
	}	
 
   handleSubmit = (event) => {
	    event.preventDefault();
	    event.stopPropagation();
	    var formData = new FormData();
	    formData.set("brand[name]", this.state.brand.dnrpa_description.toUpperCase());
	    formData.set("brand[dnrpa_code]", this.state.brand.dnrpa_code.toUpperCase());
	    formData.set("brand[dnrpa_description]", this.state.brand.dnrpa_description.toUpperCase());
	    formData.set("brand[dnrpa_maker]", (this.state.brand.dnrpa_maker) ? this.state.brand.dnrpa_maker.toUpperCase() : '');
	    formData.set("brand[aldnet_code]", (this.state.brand.aldnet_code.toUpperCase()) ? this.state.brand.aldnet_code.toUpperCase() : '');
	    formData.set("brand[aldnet_description]", (this.state.brand.aldnet_description.toUpperCase()) ? this.state.brand.aldnet_description.toUpperCase() : '');
	    formData.set("brand[aldnet_maker]", (this.state.brand.aldnet_maker.toUpperCase()) ? this.state.brand.aldnet_maker.toUpperCase() : '');
	    formData.set("brand[aldnet_maker_group]", (this.state.brand.aldnet_maker_group.toUpperCase()) ? this.state.brand.aldnet_maker_group.toUpperCase() : '');
	    var i = 0;

		if (this.state.files){
			this.state.files.map((val, idx) => {
				if (val.file !== '' && val.file !== undefined){
					formData.append("media["+i+"][file]", val.file[0])
					formData.set("media["+i+"][meta_data_name]", 'tipo_documento')
					formData.set("media["+i+"][meta_data_value]", val.meta_data)
					i++;
				}	
			})
		}


		let self = this
		const token =localStorage.getItem('userToken')
		if (this.state.action ==='new'){
		  axios.post(api.brands().post(),
		     formData,
		     {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		     )
		    .then((response)=> {
		        self.setState({errors: false, save_brand: true})
		        self.setState({message: 'Marca creada con éxito!'})
		        self.setState({dialogOpen: true})
		    })
		    .catch(function (error) {
		        self.setState({errors: true})
		        self.setState({message: 'Hubo un problema al guardar la marca. Por favor volver a intentar'})
		        self.setState({dialogOpen: true})
		  })
		} else {
			formData.set('brand[id]', this.state.brand.id)
			formData.append('_method', 'patch');
			axios.post(api.brands().patch(this.state.brand.id),
			   formData,
			   {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
			   )
			  .then((response)=> {
			      self.setState({errors: false, save_brand: true})
			      self.setState({message: 'Marca modificada con éxito!'})
			      self.setState({dialogOpen: true})
			  })
			  .catch(function (error) {
			      self.setState({errors: true, save_brand: false})
			      self.setState({message: 'Hubo un problema al guardar la marca. Por favor volver a intentar'})
			      self.setState({dialogOpen: true})
			})

		}
	}

	handleDeleteLogo = ()=>{
	    let self = this
	    const token = localStorage.getItem('userToken')
	    var id = this.state.brand.media[0].id
	    axios.delete(api.media().delete(id),{ headers: {"Authorization" : `Bearer ${token}`}},
	     {params: {'media[id]':id }}
	      )

	      .then((response)=> {
	          self.setState({errors: false})
	          var brand = this.state.brand
	          brand.media = []
	          self.setState({logo: false, brand: brand})
	          self.setState({dialogOpen: true, delete_logo: true})
	          self.setState({message: 'Logo eliminado con éxito!'})
	      })
	      .catch(function (error) {
	          self.setState({errors: true, delete_logo: false})
	          self.setState({message: 'Ocurrio un problema al intentar eliminar el logo. Contacte a su administrador.'})
	          self.setState({dialogOpen: true})
	    })
	}

	render(){
	    const handleRedirect = id => () =>{
	      window.location.href=`/brands`
	    }

	    const handleDialogClose = () => {
	      this.setState({dialogOpen: false})
	    }        

	    const disabled = this.state.disabled
	    const brand = this.state.brand
		const classes = this.props.classes;
		var aldnet_maker_groups = this.state.aldnet_makers
		var aldnet_makers = aldnet_maker_groups 
		if (brand.aldnet_maker_group){
			aldnet_makers = aldnet_maker_groups.filter(maker_group => maker_group.maker_group == brand.aldnet_maker_group)

		}
		return(
	       <Container fluid className="main-content-container px-4 pb-4">
	          <Row noGutters className="page-header pt-4">
	            <PageTitle sm="4" title={(brand.id !== undefined) ? brand.name : "Marcas"} className="text-sm-left" />
	          </Row>
	          <Row>
	            <Col md="12">
					{(this.state.logo)
						?
							<Avatar alt="Remy Sharp" src={api.media_download+'/'+this.state.brand.media[0].id} style={{width: 80, height: 80}} />						
						:
						''
					}	            
	              <React.Fragment>
	              {(this.state.dialogOpen)?
	                <Dialog
	                  open={this.state.dialogOpen}
	                  fullWidth
	                  aria-labelledby="responsive-dialog-title"
	                >
	                  <DialogTitle id="responsive-dialog-title">{"Marca"}</DialogTitle>
	                  <DialogContent>
	                    <DialogContentText>
	                        {this.state.message}
	                    </DialogContentText>
	                  </DialogContent>
	                  <DialogActions disableSpacing="false">  
                      {(this.state.save_brand)?
                        <Button onClick={handleRedirect()} variant="contained" color="primary" >
                            Aceptar
                        </Button>
                        :
                        ''
                       }
	                  {(this.state.errors || this.state.delete_logo) ?
	                      <Button onClick={handleDialogClose} variant="contained" color="primary" >
	                          Aceptar
	                      </Button>
	                      :
	                      ''
	                    }

	                  </DialogActions>
	                </Dialog>
	              :''}
	              {(this.state.loading)?
	                 <LinearProgress /> 
	              :
	              <div>
	                <form onSubmit={this.handleSubmit}>
	                	<div>
							<TextField
								id="dnrpa_code"
								name="dnrpa_code"
								label="Código DNRPA"
								disabled={disabled}
								type="text"
								required
								placeholder="Ingrese el código de DNRPA"
								onChange={this.handleChange}
								value={brand.dnrpa_code}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
							<TextField
								id="dnrpa_description"
								name="dnrpa_description"
								label="Marca DNRPA"
								disabled={disabled}
								type="text"
								required
								placeholder="Ingrese el descripción de DNRPA"
								onChange={this.handleChange}
								value={brand.dnrpa_description}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
							<TextField
								id="dnrpa_maker"
								name="dnrpa_maker"
								label="Fabricante DNRPA"
								disabled={disabled}
								type="text"
								required
								placeholder="Ingrese el fabricante de DNRPA"
								onChange={this.handleChange}
								value={brand.dnrpa_maker}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
							<TextField
								id="aldnet_code"
								name="aldnet_code"
								label="Código ALDNET"
								disabled={disabled}
								type="text"
								placeholder="Ingrese el código de ALDNET"
								onChange={this.handleChange}
								value={brand.aldnet_code}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
							<TextField
								id="aldnet_description"
								name="aldnet_description"
								label="Descripción ALDNET"
								disabled={disabled}
								type="text"
								placeholder="Ingrese el descripción de ALDNET"
								onChange={this.handleChange}
								value={brand.aldnet_description}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
{/*							<TextField
								id="aldnet_maker"
								name="aldnet_maker"
								label="Fabricante ALDNET"
								disabled={disabled}
								type="text"
								placeholder="Ingrese el fabricante de ALDNET"
								onChange={this.handleChange}
								value={brand.aldnet_maker}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
		*/}
				       <TextField
							id="aldnet_maker_group"
							name="aldnet_maker_group"
							label="Grupo Fabricante ALDNET"
							disabled={disabled}
							select
							margin="normal"
							className={classes.select}
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
						    value={brand.aldnet_maker_group}
							inputProps={{style:{fontSize: '0.75rem'}}}
				          	InputProps={{
					            style:{minWidth: 200, fontSize: '0.75rem'}
								}}
				        >
				          {aldnet_maker_groups.map((option) => (
				            <MenuItem key={option.id} value={option.maker_group} className={classes.typography}>
				              {option.maker_group}
				            </MenuItem>
				          ))}
				        </TextField>

				       	<TextField
							id="aldnet_maker"
							name="aldnet_maker"
							label="Fabricante ALDNET"
							select
							disabled={(disabled || brand.aldnet_maker_group !== '') ? false : true }
							margin="normal"
							className={classes.select}
							InputLabelProps={{
								shrink: true
							}}
			 			  	onChange={this.handleChange}
						    value={brand.aldnet_maker}
							inputProps={{style:{fontSize: '0.75rem'}}}
				          	InputProps={{
					            style:{minWidth: 200, fontSize: '0.75rem'}
								}}
				        >
				          {aldnet_makers.map((option) => (
				            <MenuItem key={option.id} value={option.maker} className={classes.typography}>
				              {option.maker}
				            </MenuItem>
				          ))}
				        </TextField>

						</div>
						{(this.state.logo)
							?
								''
							:
							<div>
		              	 		<MediaFile onChange={this.handleUploadFile} title={"Agregar logo"} width={"15rem"} height={"2rem"} meta_data={"logo"} />
							</div>
						}
	
		                {(this.state.action !== 'view')?
		                  <React.Fragment>
		                    <Button type="submit" variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
		                      Guardar
		                    </Button>
		                    <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/brands"}>
		                      Cancelar
		                    </Button>
		                    {(this.state.logo)
		                    	?
				                    <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" onClick={(e)=> {this.handleDeleteLogo()}}>
				                      Borrar Logo
				                    </Button>
			                    :
			                    ''
		                    }
		                  </React.Fragment>
		                :
		                  <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/brands"}>
		                    Volver
		                  </Button>
		                }
	              </form>
	            </div>
	            }
	            </React.Fragment>
	          </Col>
	        </Row>
	      </Container>

		)
	}  

}

export default withStyles(useStyles)(BrandsForm);